module.exports = __webpack_public_path__ + "static/legacy_bn2M@2x-3bb5c91a74d3741d5534155ff9291e57.jpg";